import { ReactNode } from "react";
import { Box } from "@mui/material";
import "../../components-styles.scss";
import "../../Dossiers/Dossier/dossier-styles.scss";
import LibraryDocumentLayoutHeader from "./LibraryDocumentLayoutHeader";
import { TabMenu } from "@/src/types";

type LibraryDocumentProps = {
    children: ReactNode;
    headerTitle: string;
    numberOfDocs: number;
    setSearchQuery: Function;
    setActiveTab: Function;
    tabsMenu: TabMenu[];
    activeTab: string;
};

export default function LibraryDocumentLayout({
    children,
    headerTitle,
    numberOfDocs,
    setSearchQuery,
    setActiveTab,
    tabsMenu,
    activeTab,
}: LibraryDocumentProps) {
    return (
        <>
            <header className="dossier-header">
                <LibraryDocumentLayoutHeader
                    headerTitle={headerTitle}
                    numberOfDocs={numberOfDocs}
                    setSearchQuery={setSearchQuery}
                    setActiveTab={setActiveTab}
                    tabsMenu={tabsMenu}
                    activeTab={activeTab}
                />
            </header>
            <main className="layout-body" style={{ overflow: "hidden" }}>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "3rem",
                        marginLeft: "6rem",
                        marginRight: "6rem",
                        marginTop: "2rem",
                        width: "80vh",
                        "@media (max-width:1024px)": {
                            marginRight: "1.5rem",
                            marginLeft: "1.5rem",
                            width: "100vh",
                        },
                        "@media (min-width: 600px) and (max-width:1024px)": {
                            width: "100vw",
                        },
                    }}
                >
                    {children}
                </Box>
            </main>
        </>
    );
}
